/* eslint-disable camelcase */
/* eslint-disable fp/no-throw */
/* eslint-disable no-else-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable fp/no-loops */
/* eslint-disable prefer-destructuring */
/* eslint-disable fp/no-mutating-methods */
/* eslint-disable no-plusplus */
/* eslint-disable fp/no-mutation */
import { TranscribeResult, TranscriptSegment, Word } from './types'

// Interface for our custom corrected transcript format
export interface CorrectedTranscriptFormat {
  version: string
  exportedAt: string
  segments: Array<{
    id: string
    speaker: string
    startTime: number
    endTime: number
    text: string
    originalText?: string
    words: Word[]
  }>
}

let idCounter = 0
const generateId = () => `${Date.now()}-${idCounter++}`

function formatVTTTime(seconds: number): string {
  let hours = Math.floor(seconds / 3600)
  let minutes = Math.floor((seconds % 3600) / 60)
  let secs = (seconds % 60).toFixed(3)

  return `${hours.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}:${secs.padStart(6, '0')}`
}

// Detect if the input is using our corrected format
export function isCorrectedFormat(data: any): boolean {
  return data && data.version && Array.isArray(data.segments)
}

// Create subtitle-friendly segments from AWS Transcribe JSON
function createSubtitleSegments(data: TranscribeResult): TranscriptSegment[] {
  let { items, speaker_labels } = data.results

  if (!items || items.length === 0) {
    return []
  }

  // Extract all words with timing information first
  let allWords: (Word & { speaker: string; originalIndex: number })[] = []

  items.forEach((item: any, index: number) => {
    if (item.type === 'pronunciation' && item.start_time && item.end_time) {
      allWords.push({
        id: generateId(),
        content: item.alternatives[0].content,
        startTime: parseFloat(item.start_time),
        endTime: parseFloat(item.end_time),
        confidence: parseFloat(item.alternatives[0].confidence),
        speaker: 'Speaker 1', // Default, will be updated below
        originalIndex: index,
      })
    }
  })

  // Now map speakers to words using the speaker_labels segments
  if (speaker_labels && speaker_labels.segments) {
    speaker_labels.segments.forEach((segment: any) => {
      let segmentStart = parseFloat(segment.start_time)
      let segmentEnd = parseFloat(segment.end_time)

      // Find all words that fall within this speaker segment
      allWords.forEach((word) => {
        if (word.startTime >= segmentStart && word.startTime <= segmentEnd) {
          // eslint-disable-next-line no-param-reassign
          word.speaker = segment.speaker_label
        }
      })
    })
  }

  if (allWords.length === 0) {
    return []
  }

  // Create subtitle-friendly segments
  let segments: TranscriptSegment[] = []
  let currentSegmentWords: (Word & { speaker: string })[] = []
  let currentSpeaker = allWords[0].speaker
  let segmentStartTime = allWords[0].startTime

  let MAX_WORDS_PER_SEGMENT = 12
  let MAX_SEGMENT_DURATION = 5.0 // seconds
  let PUNCTUATION_BREAK_CHARS = ['.', '!', '?', ':', ';']

  function finishSegment() {
    if (currentSegmentWords.length === 0) return

    let segmentEndTime =
      currentSegmentWords[currentSegmentWords.length - 1].endTime
    let text = currentSegmentWords.map((w) => w.content).join(' ')

    // Clean up the words array to remove speaker info
    let cleanWords: Word[] = currentSegmentWords.map((w) => ({
      id: w.id,
      content: w.content,
      startTime: w.startTime,
      endTime: w.endTime,
      confidence: w.confidence,
    }))

    segments.push({
      id: generateId(),
      speaker: currentSpeaker,
      startTime: segmentStartTime,
      endTime: segmentEndTime,
      words: cleanWords,
      text,
      originalText: text,
    })

    currentSegmentWords = []
  }

  for (let i = 0; i < allWords.length; i++) {
    let word = allWords[i]
    let shouldBreak = false

    // Check for speaker change
    if (word.speaker !== currentSpeaker) {
      finishSegment()
      currentSpeaker = word.speaker
      segmentStartTime = word.startTime
    }
    // Check for max words reached
    else if (currentSegmentWords.length >= MAX_WORDS_PER_SEGMENT) {
      shouldBreak = true
    }
    // Check for max duration
    else if (word.endTime - segmentStartTime > MAX_SEGMENT_DURATION) {
      shouldBreak = true
    }
    // Check for natural breaks (punctuation)
    else if (
      currentSegmentWords.length >= 4 && // Minimum 4 words before allowing punctuation break
      PUNCTUATION_BREAK_CHARS.some((char) => word.content.includes(char))
    ) {
      shouldBreak = true
    }
    // Check for longer pauses between words (more than 1 second gap)
    else if (currentSegmentWords.length > 0) {
      let lastWord = currentSegmentWords[currentSegmentWords.length - 1]
      if (word.startTime - lastWord.endTime > 1.0) {
        shouldBreak = true
      }
    }

    if (shouldBreak && currentSegmentWords.length > 0) {
      finishSegment()
      segmentStartTime = word.startTime
    }

    currentSegmentWords.push(word)
  }

  // Finish the last segment
  finishSegment()

  return segments
}

export function parseTranscribeJson(data: any): TranscriptSegment[] {
  // Check if we're dealing with our custom corrected format
  if (isCorrectedFormat(data)) {
    // Direct mapping from our corrected format
    return (data as CorrectedTranscriptFormat).segments.map((segment) =>
      // Return as-is since it already matches our TranscriptSegment structure
      ({
        id: segment.id,
        speaker: segment.speaker,
        startTime: segment.startTime,
        endTime: segment.endTime,
        words: segment.words,
        text: segment.text,
        originalText: segment.originalText || segment.text,
      }),
    )
  }

  // Standard AWS Transcribe format
  // Validate the structure
  if (!(data as TranscribeResult).results) {
    throw new Error('Invalid transcript format: missing results')
  }

  let { transcripts, items } = data.results

  if (!transcripts || transcripts.length === 0) {
    throw new Error('Invalid transcript format: no transcripts found')
  }

  // If no items array, we can't do word-level highlighting
  if (!items || items.length === 0) {
    // Create a single segment with just the transcript text
    let text = transcripts[0].transcript
    return [
      {
        id: generateId(),
        speaker: 'Speaker 1',
        startTime: 0,
        endTime: 0,
        words: [],
        text,
        originalText: text,
      },
    ]
  }

  // Use the new subtitle-friendly segmentation for original AWS Transcribe JSON
  return createSubtitleSegments(data as TranscribeResult)
}

export function generateVTT(segments: TranscriptSegment[]): string {
  let vtt = 'WEBVTT\n\n'

  segments.forEach((segment, index) => {
    let startTime = formatVTTTime(segment.startTime)
    let endTime = formatVTTTime(segment.endTime)

    vtt += `${index + 1}\n`
    vtt += `${startTime} --> ${endTime}\n`
    vtt += `<v ${segment.speaker}>${segment.text}\n\n`
  })

  return vtt
}

export function downloadVTT(content: string, filename: string) {
  let blob = new Blob([content], { type: 'text/vtt' })
  let url = URL.createObjectURL(blob)
  let a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

// Binary search to find current word
export function findCurrentWordIndex(
  segments: TranscriptSegment[],
  currentTime: number,
): { segmentId: string; wordIndex: number } | null {
  for (let segment of segments) {
    if (currentTime >= segment.startTime && currentTime <= segment.endTime) {
      // Binary search within segment words
      let left = 0
      let right = segment.words.length - 1

      while (left <= right) {
        let mid = Math.floor((left + right) / 2)
        let word = segment.words[mid]

        if (currentTime >= word.startTime && currentTime <= word.endTime) {
          return { segmentId: segment.id, wordIndex: mid }
        } else if (currentTime < word.startTime) {
          right = mid - 1
        } else {
          left = mid + 1
        }
      }
    }
  }

  return null
}

// Diff checking utilities
export interface WordDiff {
  type: 'added' | 'removed' | 'unchanged'
  word: string
  index: number
}

export function generateWordDiffs(
  originalText: string,
  newText: string,
): WordDiff[] {
  let originalWords = originalText.split(/\s+/).filter((w) => w.length > 0)
  let newWords = newText.split(/\s+/).filter((w) => w.length > 0)

  // Simple diff algorithm - could be improved with LCS/Myers algorithm for better results
  let diffs: WordDiff[] = []
  let i = 0
  let j = 0

  while (i < originalWords.length || j < newWords.length) {
    if (i >= originalWords.length) {
      // All remaining words are added
      diffs.push({ type: 'added', word: newWords[j], index: j })
      j++
    } else if (j >= newWords.length) {
      // All remaining words are removed
      diffs.push({ type: 'removed', word: originalWords[i], index: i })
      i++
    } else if (originalWords[i] === newWords[j]) {
      // Words match
      diffs.push({ type: 'unchanged', word: newWords[j], index: j })
      i++
      j++
    } else {
      // Look ahead to see if we can find a match
      let foundMatch = false

      // Check if the original word was removed
      for (let k = j + 1; k < Math.min(j + 5, newWords.length); k++) {
        if (originalWords[i] === newWords[k]) {
          // Found the original word later, so words before it are added
          for (let l = j; l < k; l++) {
            diffs.push({ type: 'added', word: newWords[l], index: l })
          }
          diffs.push({ type: 'unchanged', word: newWords[k], index: k })
          j = k + 1
          i++
          foundMatch = true
          break
        }
      }

      if (!foundMatch) {
        // Check if the new word was added
        for (let k = i + 1; k < Math.min(i + 5, originalWords.length); k++) {
          if (originalWords[k] === newWords[j]) {
            // Found the new word later, so words before it are removed
            for (let l = i; l < k; l++) {
              diffs.push({ type: 'removed', word: originalWords[l], index: l })
            }
            diffs.push({ type: 'unchanged', word: newWords[j], index: j })
            i = k + 1
            j++
            foundMatch = true
            break
          }
        }
      }

      if (!foundMatch) {
        // Assume it's a replacement
        diffs.push({ type: 'removed', word: originalWords[i], index: i })
        diffs.push({ type: 'added', word: newWords[j], index: j })
        i++
        j++
      }
    }
  }

  return diffs
}

// Export utilities
export function generateTranscriptJSON(segments: TranscriptSegment[]): string {
  let exportData = {
    version: '1.0',
    exportedAt: new Date().toISOString(),
    segments: segments.map((segment) => ({
      id: segment.id,
      speaker: segment.speaker,
      startTime: segment.startTime,
      endTime: segment.endTime,
      text: segment.text,
      originalText: segment.originalText,
      words: segment.words,
    })),
  }

  return JSON.stringify(exportData, null, 2)
}

export function downloadJSON(content: string, filename: string) {
  let blob = new Blob([content], { type: 'application/json' })
  let url = URL.createObjectURL(blob)
  let a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
